import Book from './Book';

export const MainRoutes = [{
  path: 'book',
  name: 'Book',
  component: Book,
}];

export default MainRoutes;
